import { SearchFieldKeys, TableColumn } from "@sso/types";

export const productLicenceTableColumns: TableColumn<string>[] = [
  {
    name: "Product",
    field: "Name",
    sortable: true,
    search: { type: SearchFieldKeys.TEXT },
  },
  {
    name: "Number of Licenced Users",
    field: "numberOfLicencedUsers",
    sortable: true,
  },
];
